import { render } from "./FirmwarePage.vue?vue&type=template&id=fbe5d49c"
import script from "./FirmwarePage.vue?vue&type=script&lang=js"
export * from "./FirmwarePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/Box/FirmwarePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbe5d49c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbe5d49c', __exports__)) {
    api.reload('fbe5d49c', __exports__)
  }
  
  module.hot.accept("./FirmwarePage.vue?vue&type=template&id=fbe5d49c", () => {
    api.rerender('fbe5d49c', render)
  })

}


export default __exports__